// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.don {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.don .search {
  margin: 20px 0;
}
.don .content {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Don/ShowDon/showDon.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,aAAA;EACA,6BAAA;EACA,WAAA;AAAJ","sourcesContent":[".don {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .search {\n    margin: 20px 0;\n  }\n\n  .content {\n    display: flex;\n    justify-content: space-evenly;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
